import { render, staticRenderFns } from "./AttributesView.vue?vue&type=template&id=fa5992cc&lang=pug&"
import script from "./AttributesView.vue?vue&type=script&lang=js&"
export * from "./AttributesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports